import React from 'react';

const banner = `${process.env.PUBLIC_URL}/photos/projects/english-camp-1.jpg`;
const poster = `${process.env.PUBLIC_URL}/photos/projects/english-camp-3.png`;
const group = `${process.env.PUBLIC_URL}/photos/projects/english-camp-2.jpg`;

const Projects = () => {
    return (
        <section id="projects" className="section">
            <div className="container">
                <div className="section-head reveal">
                    <h2 className="section-title">Наши <span className="accent">проекты</span></h2>
                </div>

                <div className="card-glass project-card reveal">
                    <div className="project-banner">
                        <img src={banner} alt="English Summer Camp — слёт любителей английского языка"/>
                    </div>

                    <div className="project-body">
                        <span className="project-kicker">Слёт любителей английского языка</span>
                        <h3 className="project-name">English Summer Camp</h3>
                        <span className="badge-closed">Проект завершён · лето 2026</span>

                        <div className="project-info">
                            <h4>Информация о проекте</h4>
                            <p>
                                Каждый, кто учил новый язык, сталкивался с языковым барьером. Наша миссия —
                                помочь сломать языковой барьер каждому, кто приедет к нам на слёт!
                            </p>
                            <p>
                                Проект существует как интеграционная площадка, объединяющая различных людей,
                                желающих практиковать общение на английском языке, независимо от уровня владения
                                им. В проекте могут участвовать люди разного возраста, социального статуса и
                                семейного положения, мы приглашаем к участию социально незащищённые слои общества
                                и бизнесменов, домохозяек и профессоров… Главное — интерес к английскому, остальные
                                условности стоит оставлять дома.
                            </p>
                            <p className="project-closed-note">Проект закрыт летом 2026 года.</p>
                        </div>

                        <div className="project-gallery">
                            <img src={poster} alt="Афиша слёта English Summer Camp"/>
                            <img src={group} alt="Участники слёта English Summer Camp"/>
                        </div>

                        <a className="btn-grad" href="https://superlager.ru/" target="_blank" rel="noopener noreferrer">
                            Перейти на сайт лагеря →
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Projects;
